module.exports = __webpack_public_path__ + "static/media/Arrow-up-light-blue.7c435521.svg";